module.exports = __webpack_public_path__ + "static/media/rent-banner.4479349e.png";